import script from "./PolicyDropFile.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyDropFile.vue?vue&type=script&setup=true&lang=js"

import "./PolicyDropFile.vue?vue&type=style&index=0&id=7734b3d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7734b3d2"]])

export default __exports__